import { HttpErrorResponse } from '@angular/common/http';
import { isObject, isString } from 'lodash';

export function GetErrorMessageFromResponse(
  error: HttpErrorResponse & { tracer?: string },
  defaultErrorMessage: string = 'An unexpected error occurred'
): string {
  if (isString(error?.error?.message)) {
    return error.error.message;
  }

  if (isString(error?.error?.error)) {
    return error.error.error;
  }

  if (error?.error?.errors) {
    if (isObject(error?.error?.errors)) {
      const errors = Object.values(error.error.errors);
      if (errors.length > 0) {
        return errors.join(', ');
      }
    } else if (isString(error?.error?.errors)) {
      return error.error.errors;
    }
  }

  if (isString(error?.error)) {
    return error.error;
  }

  if (isString(error?.message)) {
    return error.message;
  }

  if (isString(error?.tracer)) {
    return error.tracer.split('\n')[0] || defaultErrorMessage;
  }

  return defaultErrorMessage;
}
